// extracted by mini-css-extract-plugin
export default {"productsmain":"product_main_productsmain__3snxv","products_container":"product_main_products_container__jDH5B"};